// =====================================================================
// PrerollsListExt.jsx — lista PREROLL AUDIO con paging 10/volta
// =====================================================================
import React, { useEffect, useState } from 'react'
import api        from '../../services/api'
import Loader     from '../Utils/Loader'
import Modal      from '../common/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash, faToggleOn, faToggleOff, faPlay } from '@fortawesome/free-solid-svg-icons'
import '../../css/prerollsList.css'

const API_BASE    = '/prerolls-ext'
const placeholder = '/img/placeholder-cover.jpg'
const getSrc      = r => (r.mediaType === 'video' ? r.url : r.url || `/uploads/audio/${r.filename}`)
const PAGE_SIZE   = 10

export default function PrerollsListExt({ onEdit, onChange, refreshKey }) {
  const [rows,   setRows]    = useState([])
  const [loading,setLoading] = useState(true)
  const [search, setSearch]  = useState('')
  const [preview,setPreview] = useState(null)
  const [page,   setPage]    = useState(1)      // ← numero pagina

  /* fetch ogni refreshKey */
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(API_BASE)
        setRows(data.filter(r => r.mediaType === 'audio'))
      } finally { setLoading(false) }
    })()
  }, [refreshKey])

  /* reset pagina se cambia la ricerca */
  useEffect(() => { setPage(1) }, [search, refreshKey])

  if (loading) return <Loader />

  /* --- helper azioni REST --- */
  const handleDelete = async id => {
    if (!window.confirm('Vuoi eliminare questo preroll?')) return
    await api.delete(`${API_BASE}/${id}`)
    onChange()
  }

  const handleToggle = async r => {
    await api.put(`${API_BASE}/${r.id}`, { enabled: !r.enabled })
    onChange()
  }

  /* filtro + slice pagina --------------------------------------------- */
  const filtered   = rows.filter(r =>
    r.filename?.toLowerCase().includes(search.toLowerCase())
  )
  const visible    = filtered.slice(0, page * PAGE_SIZE)
  const hasMore    = visible.length < filtered.length
  const loadMore   = () => setPage(p => p + 1)

  /* render list */
  return (
    <div className="preroll-list">
      <div className="preroll-list-search">
        <input type="text" className="preroll-search" placeholder="Cerca filename…"
               value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      <div className="preroll-list-items" aria-live="polite">
        <div className="preroll-row head" role="row">
          <span>ID</span><span>Nome file</span>
          <span>Dal</span><span>Al</span>
          <span>Cover</span><span>Tipo</span><span>Ordine</span>
          <span className="actions">Azioni</span>
        </div>

        {visible.map(r => (
          <div key={r.id} className="preroll-row body" role="row">
            <span data-label="ID">{r.id}</span>
            <span className="filename" data-label="Nome">{r.filename}</span>
            <span data-label="Dal">{r.startTime ? new Date(r.startTime).toLocaleString('it-IT') : '—'}</span>
            <span data-label="Al">{r.endTime ? new Date(r.endTime).toLocaleString('it-IT') : '—'}</span>
            <div className="cover" data-label="Cover">
              <img src={r.coverUrl || placeholder} alt={`cover ${r.filename}`} loading="lazy"
                   onClick={() => setPreview(r)} tabIndex={0} />
            </div>
            <span data-label="Tipo">{r.type}</span>
            <span data-label="Ordine">{r.prio}</span>
            <div className="actions" data-label="Azioni">
              <button className="preview" title="Anteprima" onClick={() => setPreview(r)}>
                <FontAwesomeIcon icon={faPlay} /></button>
              <button className="edit" title="Modifica" onClick={() => onEdit(r)}>
                <FontAwesomeIcon icon={faEdit} /></button>
              <button className="delete" title="Elimina" onClick={() => handleDelete(r.id)}>
                <FontAwesomeIcon icon={faTrash} /></button>
              <button className="toggle" title="Attiva/Disattiva" onClick={() => handleToggle(r)}>
                <FontAwesomeIcon icon={r.enabled ? faToggleOn : faToggleOff} /></button>
            </div>
          </div>
        ))}

        {/* bottone load-more */}
        {hasMore && (
          <div className="preroll-row load-more">
            <button className="btn-load-more" onClick={loadMore}>
              Carica altri…
            </button>
          </div>
        )}
      </div>

      <Modal open={Boolean(preview)} onClose={() => setPreview(null)}>
        {preview && (
          <>
            <h3 style={{ marginTop: 0 }}>{preview.filename}</h3>
            <audio src={getSrc(preview)} controls style={{ width: '100%' }} />
          </>
        )}
      </Modal>
    </div>
  )
}
